// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const vivillon: PokeData = {
  "id": 666,
  "name": "vivillon",
  "height": 12,
  "weight": 170,
  "base_experience": 185,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "supersonic",
    "psybeam",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "light-screen",
    "safeguard",
    "aromatherapy",
    "bug-buzz",
    "quiver-dance",
    "struggle-bug",
    "hurricane",
    "draining-kiss",
    "powder"
  ],
  "moves": [
    "gust",
    "supersonic",
    "poison-powder",
    "stun-spore",
    "aromatherapy",
    "bug-buzz",
    "hurricane",
    "sticky-web",
    "aerial-ace",
    "brave-bird",
    "infest",
    "acrobatics",
    "chatter"
  ],
  "evolution_chain": {
    "id": 342,
    "item": null,
    "species": [
      {
        "name": "scatterbug",
        "order": 665,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "spewpa",
        "order": 666,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 664,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 9,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "vivillon",
        "order": 667,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 665,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 12,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 107,
    "speed": 146,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
